import { NotificationService } from './../services/notification.service';
import { Directive, ElementRef, EventEmitter, HostListener, OnDestroy, Output } from '@angular/core';

@Directive({
  selector: '[appFileChooser]'
})
export class FileChooseDirective implements OnDestroy {
  @Output() appFileChooser = new EventEmitter();
  private fileEL: HTMLInputElement;

  constructor(private hostEl: ElementRef, private notificationService: NotificationService) {

    this.fileEL = document.createElement('input');
    this.fileEL.setAttribute('type', 'file');
    this.fileEL.style.display = 'none';
    this.fileEL.addEventListener('change', (ee) => {
      if (this.fileEL.files) {
        this.appFileChooser.emit(this.fileEL.files);
      } else if (ee['path']) {
        this.appFileChooser.emit(ee['path'][0].files);
      } else {
        this.notificationService.show('error', 'Something wrong with file chooser');
      }
    });

    // for osx mobile devices element should be appended to the dom
    this.hostEl.nativeElement.parentNode.appendChild(this.fileEL);
  }

  @HostListener('click') mouseclick() {
    this.fileEL.click();
  }

  ngOnDestroy() {
    this.fileEL.remove();
    this.fileEL = null;
  }

}
